<script>
import { mapState } from 'vuex'

export default {
  props: { responders: { type: Array } },

  created() {
    this.refresh()
  },

  data() {
    return {
      loading: true,
    }
  },

  computed: {
    ...mapState('client/feedbackRequests', {
      feedbackRequests: 'all',
      loadingFeedbackRequests: 'loading',
    }),

    groupedByOpportunity() {
      let feedbackRequests = JSON.parse(JSON.stringify(this.feedbackRequests))
      let grouped = {}

      feedbackRequests.forEach(fr => {
        if (!grouped[fr.opportunityApplication.opportunity.id]) {
          grouped[fr.opportunityApplication.opportunity.id] = []
        }

        grouped[fr.opportunityApplication.opportunity.id].push(fr)
      })

      return grouped
    },
  },

  methods: {
    refresh() {
      let params = {}
      Object.keys(this.$props).forEach(key => {
        if (key === 'responders') params['responders'] = this.responders.map(t => t.id)
      })
      this.$store
        .dispatch('client/feedbackRequests/fetchAll', params)
        .then(() => (this.loading = false))
    },
  },

  render() {
    return this.$scopedSlots.default({
      feedbackRequests: this.feedbackRequests,
      groupedByOpportunity: this.groupedByOpportunity,
      loading: this.loading,
    })
  },
}
</script>
